import { PlayCircle } from "lucide-react";
import { REPLAY_VIDEO_URL } from "../../config/replay";

const youtubeId = (u) => {
  if (/youtu\.be$/.test(u.hostname)) return u.pathname.slice(1).split("/")[0];
  if (!/(^|\.)youtube(-nocookie)?\.com$/.test(u.hostname)) return null;
  if (u.searchParams.get("v")) return u.searchParams.get("v");
  const m = u.pathname.match(/^\/(embed|shorts|live)\/([^/?]+)/);
  return m ? m[2] : null;
};

const vimeoEmbed = (u) => {
  if (!/(^|\.)vimeo\.com$/.test(u.hostname)) return null;
  const parts = u.pathname.split("/").filter(Boolean);
  const idx = parts.findIndex((p) => /^\d+$/.test(p));
  if (idx < 0) return null;
  const hash = u.searchParams.get("h") || (parts[idx + 1] && /^[a-f0-9]+$/i.test(parts[idx + 1]) ? parts[idx + 1] : null);
  return `https://player.vimeo.com/video/${parts[idx]}${hash ? `?h=${hash}` : ""}`;
};

export const resolveReplaySource = (raw) => {
  const url = (raw || "").trim();
  if (!url) return null;
  try {
    const u = new URL(url, window.location.origin);
    const yt = youtubeId(u);
    if (yt) return { type: "iframe", src: `https://www.youtube-nocookie.com/embed/${yt}?rel=0` };
    const vm = vimeoEmbed(u);
    if (vm) return { type: "iframe", src: vm };
    return { type: "video", src: u.href };
  } catch {
    return null;
  }
};

const FRAME = "relative aspect-video w-full overflow-hidden rounded-xl border border-[var(--gold)] bg-black shadow-[0_0_60px_-8px_rgba(232,184,74,0.45)]";

export const ReplayVideo = () => {
  const source = resolveReplaySource(REPLAY_VIDEO_URL);
  if (!source) {
    return (
      <div className={`${FRAME} lux-card grid place-items-center`} data-testid="replay-video-placeholder">
        <div className="flex flex-col items-center gap-3 text-center">
          <PlayCircle className="h-14 w-14 text-[var(--gold)] sm:h-20 sm:w-20" strokeWidth={1.2} aria-hidden="true" />
          <p className="font-mono-plex text-[12px] tracking-[0.2em] text-[#efe6d1] sm:text-[13px]">Webinar replay</p>
        </div>
      </div>
    );
  }
  return (
    <div className={FRAME} data-testid="replay-video">
      {source.type === "iframe" ? (
        <iframe src={source.src} title="Webinar replay" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" allowFullScreen className="absolute inset-0 h-full w-full" />
      ) : (
        <video src={source.src} controls playsInline preload="metadata" className="absolute inset-0 h-full w-full bg-black" aria-label="Webinar replay" />
      )}
    </div>
  );
};
